import { render, staticRenderFns } from "./ReplyUserRights.vue?vue&type=template&id=7d87b89a&scoped=true&"
import script from "./ReplyUserRights.vue?vue&type=script&lang=ts&"
export * from "./ReplyUserRights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d87b89a",
  null
  
)

export default component.exports